module.exports = __webpack_public_path__ + "static/img/xd_2_e.47a81f8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/xd_2_e.png
// module id = drys
// module chunks = 1